import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/curly';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduceMotion = useReducedMotion();
  return <section className="border-b border-white/5 bg-cocoa py-20" aria-labelledby="faq-title" data-id="element-14" data-mp="3r7is558pxngu">
      <div className="mx-auto w-full max-w-3xl px-6" data-id="element-15" data-mp="3v948j0kgojvs">
        <h2 id="faq-title" className="font-display text-3xl text-cream sm:text-4xl" data-id="element-16" data-mp="43uf0yx9dnhf">
          Preguntas frecuentes
        </h2>

        <dl className="mt-10 divide-y divide-white/10 border-y border-white/10" data-id="element-17" data-mp="8we4at5b6722">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="py-2" data-id="element-18" data-mp="ivd55pju0yei" data-mpi={index}>
                <dt data-id="element-19" data-mp="muvncdk9qvdn">
                  <button type="button" aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-6 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-20" data-mp="mwf38320j4ew">
                    <span className="font-medium text-cream" data-id="element-21" data-mp="2w3htv7jrimax">{faq.question}</span>
                    <PlusIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out" style={{
                  transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
                }} data-id="element-22" data-mp="2w5kv6nqd81uy" />
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-23" data-mp="3f2lx1zomhluo">
                  {isOpen && <motion.dd initial={reduceMotion ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduceMotion ? undefined : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: EASE
              }} className="overflow-hidden" data-id="element-24" data-mp="gcc1qx5h8gbn">
                      <p className="pb-5 pr-10 leading-relaxed text-sand" data-id="element-25" data-mp="2audk34qh99jr">{faq.answer}</p>
                    </motion.dd>}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}